import { ICompany } from '@company/company.structures';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IChartData, IChartDataset, IErrorResponse } from '@base/interfaces';
import { LoggerService } from '@base/logger/logger.service';
import { Subscription } from 'rxjs';
import { TODAY, COLORS } from '@base/utils';
import * as _ from 'lodash';
import { CompanyService } from '@base/company/company.service';
import { ExceptionService } from '@base/exceptions.service';

const range = {
  start: TODAY.start(),
  end: TODAY.end(),
};

@Component({
  selector: 'app-leader-dashboard',
  templateUrl: './leader-dashboard.component.html',
  styleUrls: ['./leader-dashboard.component.sass']
})
export class LeaderDashboardComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private companiesAllowed: ICompany[];

  // parametros que se envian...
  dataSource = [];
  chartData: IChartData;
  chartType = 'line';
  day = range;

  constructor(
    private loggerService: LoggerService,
    private companyService: CompanyService,
    private exceptionService: ExceptionService,
  ) {
    this.subscriptions = [];
    this.companiesAllowed = [];

    const currentCompaniesSubscription: Subscription = this.companyService.observeCompanies().subscribe(
      (companies: ICompany[]) => {
        this.companiesAllowed = companies;
        this.getLogs();
      },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );
    this.subscriptions = [...this.subscriptions, currentCompaniesSubscription];
  }

  ngOnInit() {
    //
  }

  ngOnDestroy(): void {
    this.subscriptions.map((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  private adaptLogsByCompany(logs: []) {
    let auxLogs = [];
    let finalLogs = [];

    this.companiesAllowed.map((company: ICompany) => {
      auxLogs = [...auxLogs, logs.filter(log => log['company_name'] === company.name)];
    });

    auxLogs.map((data) => {
      finalLogs = finalLogs.concat(data);
    });

    return finalLogs;
  }

  private getLogs() {
    const logsSubscription: Subscription = this.loggerService.getLogsByDate(range).subscribe(
      (logs: []) => {
        const auxLogs = [...logs];
        this.dataSource = this.adaptLogsByCompany(auxLogs as []);
        let rgbs = [];
        let borders = [];
        let values = [];
        let labels = [];
        const dataGroupedBy = {
          company: _.groupBy(this.dataSource, 'company_name'),
          hour: _.groupBy(this.dataSource, 'hour'),
        };

        Object.keys(dataGroupedBy.hour).map((hour) => {
          const tempRgb = COLORS.GENERATE_COLOR();
          rgbs = [...rgbs, `rgb(${tempRgb.r}, ${tempRgb.g}, ${tempRgb.b}, 0.5)`];
          borders = [...borders, COLORS.FULL_COLOR_HEX(tempRgb)];
          values = [...values, dataGroupedBy.hour[hour].reduce(function (accumulator, pilot) {
            return accumulator + pilot['total'];
          }, 0)];
          labels = [...labels, hour];
        });

        const chartDataset: IChartDataset = {
          label: 'Total conexiones',
          backgroundColor: rgbs,
          borderColor: borders,
          borderWidth: 0.5,
          data: values,
          fill: false,
          pointRadius: 10,
          pointHoverRadius: 15,
          lineTension: 0,
          type: 'line',
        };

        this.chartData = {
          labels: labels,
          datasets: [chartDataset],
        };
    },
    (err: HttpErrorResponse) => {
      const error: IErrorResponse = this.exceptionService.errorHandling(err);
    });
    this.subscriptions = [...this.subscriptions, logsSubscription];
  }

  getSubset(event) {
    if (typeof event !== 'undefined') {
      console.log(event);
    }
  }
}
